<template>
  <img alt="Vue logo" src="./assets/logo.png">
  <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
  <pre>{{result}}</pre>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
  name: 'App',
  data() {
    return {
      result: 'hola'
    }
  },
  components: {
    StreamBarcodeReader
  },
  methods: {
    onDecode(result) {
      this.result = result
      console.log(result)
    },
    onLoaded(result) {
      this.result = 'cargado'
      console.log(result)
    }

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
